import request from '../../axios';

const postActivePromotion = async (payload: IActivePromotionPayload) => {
  await request.post('/api/v2/subscription/active-promotion', {
    ...payload,
  });
};
export default postActivePromotion;
